import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ToastContext, Message, CheckboxLabel, TooltipHelp } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import Styles from '../managementRulesList.module.css';

export default function DeleteModal({ show, sync, onClose, organizationId, subscriptionId, subscription }) {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);
    const [cleanTickets, setCleanTickets] = React.useState(false);

    const onDelete = React.useCallback(() => {
        const queryParams = cleanTickets ? { clean_tickets: true } : { unfilter_tickets: true };
        subscription
            .delete({ organizationId, subscriptionId, id: subscription.id }, queryParams)
            .then(() => {
                sync({ cache: false, allow_cache: false });
                toast.success(t('ticket.common.cta.removed'));
            })
            .catch(() => {
                toast.error(t('ticket.webservice.list.modal.error'));
            })
            .finally(() => {
                onClose();
            });
    }, [subscription, organizationId, subscriptionId, cleanTickets, onClose, sync, toast]);

    return (
        <Modal
            open={show}
            onClose={onClose}
            title={t('ticket.webservice.management-rules.modal.title')}
            submitButton={
                <Button primary onClick={onDelete}>
                    {t('ticket.common.cta.yes')}
                </Button>
            }
            cancelButton={<Button onClick={onClose}>{t('ticket.common.cta.no')}</Button>}
        >
            <div className={Styles['delete-modal-content']}>
                <div>{t('ticket.webservice.management-rules.modal.body')}</div>
                <Message type="default" title={t('ticket.webservice.management-rules.modal.unfilterTicketsInfo')} className={Styles['delete-modal-infobox']}>
                    {t('ticket.webservice.management-rules.modal.unfilterTicketsMessage')}
                </Message>
                <div className={Styles['delete-modal-checkbox']}>
                    <CheckboxLabel
                        label={
                            <>
                                {t('ticket.webservice.management-rules.modal.cleanTicketsLabel')}
                                <TooltipHelp triggerOnHover title={t('ticket.webservice.management-rules.modal.cleanTicketsTooltip')} />
                            </>
                        }
                        onChange={(_, { checked }) => setCleanTickets(checked)}
                        checked={cleanTickets}
                    />
                </div>
            </div>
        </Modal>
    );
}

DeleteModal.propTypes = {
    show: PropTypes.bool.isRequired,
    sync: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    organizationId: PropTypes.string.isRequired,
    subscription: PropTypes.object.isRequired,
    subscriptionId: PropTypes.string.isRequired
};
